import Toggle from './Toggle.component';

export default Toggle;
